// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"confirmation_cancelButton_11eb2w7"};